import Navbar from './Navbar';

const StickyNavbar = () => {
  return (
    <div className="sticky top-4 z-30 flex justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full px-4 max-w-6xl bg-transparent backdrop-blur-2xl rounded-full border border-gray-300/30 shadow-lg">
        <Navbar />
      </div>
    </div>
  );
};

export default StickyNavbar;